import React from 'react';
import Draggable from 'react-draggable';
import axios from '../../../axios-config.js';
import {connect} from 'react-redux';
import {closeModal} from '../../../Redux/actions/ui.js';
import { selectPermissionCapabilities } from '../../../utils/permissions.js';

let CloseButton = (props) => {
  return (
    <div onClick={props.handleClick} className="ProjectHistoryHeaderBtn close">
      <i className="material-icons notranslate">close</i>
    </div>
  )
}

let MinimizeButton = (props) => {
  return (
    <div className="ProjectHistoryHeaderBtn" onClick={props.toggleMinimize}>
      <i className="material-icons notranslate">{props.minimized ? "crop_square" : "remove"}</i>
    </div>
  )
}

let AssetForm = (props) => {
  // Calculate size in MB without rounding yet to preserve accuracy
  let sizeInMB = props.size / 1024 / 1024;

  const selectDisabled = props.modalType === "mesh" && !props.canAddPasteModels;

  let handleSelect = (e) => {
    if (selectDisabled) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      return;
    }
    if (props.modalType === "mesh") {
      if (props.isSubGroup) {
        Inventum.models.addModelToSubGroup(props.referenceID,props.s3_path,props.original_file_name);
      } else {
        Inventum.models.addModel(props.referenceID,props.s3_path,props.original_file_name);
      }
    }else {
      Inventum.models.setTexture(props.referenceID,props.s3_path);
    }
  }

  let handleDelete = () => {
    /*let deleteConfirm = prompt("Type YES to Delete:","");
    if (deleteConfirm.toUpperCase() !== "YES") {
      return;
    }*/

    let url = `/project/${props.projectID}/assets/${props.id}`;
    axios.delete(url)
    .then(response => {
      props.getAssets();//Update list of assets after deleting.
    })
    .catch(error => {
      console.log(error);
    });
  }

  let handleLink = () => {
    navigator.clipboard.writeText(props.s3_path)
    .then(() => {
      Inventum.notifications.addNotification({content:"Copied asset link to clipboard",displayTime:3000})
    })
  }

  // Truncate filename if longer than 60 characters
  const displayName = props.original_file_name.length > 60 
    ? props.original_file_name.substring(0, 60) + '...' 
    : props.original_file_name;

  var updated_at = new Date(props.updated_at);
  
  // Format size display with 2 decimal points
  let sizeDisplay, sizeUnit;
  if (sizeInMB < 1) {
    // Show in KB if less than 1 MB
    sizeDisplay = (sizeInMB * 1024).toFixed(2);
    sizeUnit = "KB";
  } else {
    // Show in MB
    sizeDisplay = sizeInMB.toFixed(2);
    sizeUnit = "MB";
  }
  
  return (
    <tr>
      <td className="asset-name-cell" title={props.original_file_name}>{displayName}</td>
      <td className="asset-date-cell" title={updated_at}>{`${updated_at.getDate()}/${updated_at.getMonth() + 1}/${updated_at.getFullYear().toString().substr(-2)}`}</td>
      <td className="asset-action-cell">
        <div className="WorldEditorButton copy-link-btn" onClick={handleLink}>
          <i className="material-icons notranslate">content_copy</i>
          <span>Link</span>
        </div>
      </td>
      <td className="asset-size-cell">{sizeDisplay} {sizeUnit}</td>
      <td className="asset-action-cell">
        <div
          className={`WorldEditorButton${selectDisabled ? " Unavailable" : ""}`}
          onClick={handleSelect}
          aria-disabled={selectDisabled}
          title={selectDisabled ? "Site admins only" : undefined}>Select</div>
      </td>
      <td className="asset-action-cell">
        <div className="WorldEditorButton delete-btn" onClick={handleDelete}>Delete</div>
      </td>
    </tr>
  )
}

class AssetsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      assets:[],
      uploadComplete:false,
      currentlyUploading:false,
      fileCount:0,
      fileIndex:0,
      erroredFiles:[],
      activeFileName:'',
      activeFileSize:0,
      progressPercent:0
    };
    this.getAssets = this.getAssets.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
  }

  componentDidMount() {
    this.getAssets();
  }

  componentDidUpdate(prevProps, prevState) {
    // Only update compact mode when upload state changes
    if (this.props.setCompactMode) {
      const isCompactNow = this.state.currentlyUploading || this.state.uploadComplete;
      const wasCompactBefore = prevState.currentlyUploading || prevState.uploadComplete;
      
      if (isCompactNow !== wasCompactBefore) {
        this.props.setCompactMode(isCompactNow);
      }
    }
  }

  handleUpload(e) {
    e.persist();
    let fileIndex = 0;
    let fileCount = e.target.files.length;
    let erroredFiles = [];
    if (fileCount === 0) {
      return;
    }

    let activeFileName = e.target.files[fileIndex].name;
    let activeFileSize = e.target.files[fileIndex].size;
    this.setState({currentlyUploading:true,fileIndex,fileCount,activeFileName,activeFileSize});

    let onUploadProgress = (e) => {
      this.setState({progressPercent:Math.round((e.loaded * 100) / e.total)});
    }

    let sendFile = (file) => {
      var form = new FormData();
      form.append('asset', file);
      form.append('projectID', this.props.activeProject);
      axios.post(`/upload/`, form, { onUploadProgress })
      .then(response => {
        fileIndex++;
        if (fileIndex < fileCount) {
          activeFileName = e.target.files[fileIndex].name;
          activeFileSize = e.target.files[fileIndex].size;
          this.setState({fileIndex,activeFileName,activeFileSize,progressPercent:0});
          sendFile(e.target.files[fileIndex]);
        } else {
          this.setState({uploadComplete:true,currentlyUploading:false,fileIndex:0,activeFileName:'',activeFileSize:0,progressPercent:0});
        }
      })
      .catch(error => {
        console.log(error);
        //Update the errored Files List
        erroredFiles.push(e.target.files[fileIndex].name);
        this.setState({erroredFiles});
        fileIndex++;
        if (fileIndex < fileCount) {
          activeFileName = e.target.files[fileIndex].name;
          activeFileSize = e.target.files[fileIndex].size;
          this.setState({fileIndex,activeFileName,activeFileSize,progressPercent:0});
          sendFile(e.target.files[fileIndex]);
        }else{
          this.setState({uploadComplete:true,currentlyUploading:false,fileIndex:0,activeFileName:'',activeFileSize:0,progressPercent:0});
        }
      });
    }

    sendFile(e.target.files[fileIndex]);

  }

  getAssets() {
    axios.get(`/project/${this.props.activeProject}/assets`)
    .then((result) => {
      let data = result.data;
      data.sort((a, b) => {
        let dateA = new Date(a.updated_at);
        let dateB = new Date(b.updated_at);

        if (dateA > dateB) {
          return -1
        }

        if (dateA < dateB) {
          return 1
        }

        return 0;
      })
      this.setState({assets:data})
    })
    .catch((error) => {
      console.log(error);
    })
  }

  render() {
    //Only shows assets that match the type of modalOptions.type
    //This is so we can only show the mesh models when selecting a mesh or images when selecting a texture
    let assets = this.state.assets.filter(asset => {
      return asset.type === this.props.modalOptions.type;
    })

    if (this.state.currentlyUploading) {
      // Calculate file size with conditional KB/MB display (consistent with AssetForm)
      let uploadSizeInMB = this.state.activeFileSize / 1024 / 1024;
      let uploadSizeDisplay, uploadSizeUnit;
      if (uploadSizeInMB < 1) {
        uploadSizeDisplay = (uploadSizeInMB * 1024).toFixed(2);
        uploadSizeUnit = "KB";
      } else {
        uploadSizeDisplay = uploadSizeInMB.toFixed(2);
        uploadSizeUnit = "MB";
      }

      return (
        <div className="WorldEditorDrawer uploadingState">
          <div className="uploadStateIcon">
            <i className="material-icons notranslate">cloud_upload</i>
          </div>
          <div className="uploadStateTitle">Uploading Assets</div>
          <div className="uploadStateInfo">
            <div className="uploadFileCount">File {this.state.fileIndex + 1} of {this.state.fileCount}</div>
            <div className="uploadFileName">{this.state.activeFileName}</div>
            <div className="uploadFileSize">{uploadSizeDisplay} {uploadSizeUnit}</div>
          </div>
          <ProgressBar percent={this.state.progressPercent} />
        </div>
      )
    }

    if (this.state.uploadComplete) {
      const hasErrors = this.state.erroredFiles.length > 0;
      const successCount = this.state.fileCount - this.state.erroredFiles.length;
      const allFailed = successCount === 0;

      let icon, title, message, iconClass;
      if (allFailed) {
        // All files failed
        icon = "error";
        iconClass = "error";
        title = "Upload Failed";
        message = "All files failed to upload. Please check your files and try again.";
      } else if (hasErrors) {
        // Some files failed
        icon = "warning";
        iconClass = "warning";
        title = "Upload Partially Complete";
        message = `${successCount} of ${this.state.fileCount} file(s) uploaded successfully. ${this.state.erroredFiles.length} file(s) failed.`;
      } else {
        // All succeeded
        icon = "check_circle";
        iconClass = "success";
        title = "Upload Complete!";
        message = `All ${this.state.fileCount} file(s) uploaded successfully.`;
      }

      return (
        <div className="WorldEditorDrawer uploadComplete">
          <div className={`uploadCompleteIcon ${iconClass}`}>
            <i className="material-icons notranslate">{icon}</i>
          </div>
          <div className="uploadCompleteTitle">{title}</div>
          <div className="uploadCompleteMessage">
            <p>{message}</p>
            {hasErrors && (
              <div className="erroredFilesList">
                <p style={{marginTop: '10px', fontWeight: '600', color: '#ff6b6b'}}>Failed files:</p>
                <ul style={{margin: '5px 0', paddingLeft: '20px', textAlign: 'left', maxHeight: '100px', overflowY: 'auto'}}>
                  {this.state.erroredFiles.map((fileName, index) => (
                    <li key={index} style={{color: '#ff6b6b', fontSize: '12px'}}>{fileName}</li>
                  ))}
                </ul>
              </div>
            )}
            {!allFailed && (
              <p style={{marginTop: '12px'}}>Processing may take a few moments. Refresh this menu to see your {hasErrors ? 'successfully uploaded' : 'new'} assets.</p>
            )}
          </div>
          <div className="uploadCompleteActions">
            <div className="WorldEditorButton primary" onClick={()=>{this.getAssets();this.setState({uploadComplete:false, erroredFiles:[]})}}>
              {allFailed ? "Close" : "Refresh Assets"}
            </div>
          </div>
        </div>
      )
    }

    let accepts = "";
    let modalType = this.props.modalOptions.type;
    let selectButtonText = "Add To Scene";
    if (modalType === "mesh") {
      selectButtonText = "Add To Scene";
      accepts = ".obj";
    } else if (modalType === "image") {
      selectButtonText = "Use as Texture";
      accepts = ".jpg, .jpeg, .png"
    }

		const uploadDisabled = false; // Temporary disabled uploading assets.

		return (
      <div className="WorldEditorDrawer">
        <table className="ProjectHistoryTableContainer AssetManagerTable">
          <thead>
            <tr>
              <th className="asset-name-cell">Name</th>
              <th className="asset-date-cell">Date</th>
              <th className="asset-action-cell">File Location</th>
              <th className="asset-size-cell">File Size</th>
              <th className="asset-action-cell">{selectButtonText}</th>
              <th className="asset-action-cell">Delete</th>
            </tr>
          </thead>
          <tbody>
            {assets.map((asset,index) => <AssetForm modalType={modalType} projectID={this.props.activeProject} referenceID={this.props.modalOptions.referenceID} isSubGroup={this.props.modalOptions.isSubGroup} canAddPasteModels={this.props.canAddPasteModels} closeModal={this.props.closeModal} getAssets={this.getAssets} key={index} {...asset}/>)}
          </tbody>
        </table>
        <input accept={accepts} multiple id="myInput" type="file" ref={(ref) => this.upload = ref} style={{display: 'none'}} onChange={this.handleUpload}/>
        { uploadDisabled ? <div className="WorldEditorButton">Uploading Disabled</div> : <div className="WorldEditorButton upload-asset-btn" onClick={()=>{this.upload.click()}}><i className="material-icons notranslate">cloud_upload</i><span>Upload Asset</span></div>}
        <div className="AssetRefreshButton" onClick={this.getAssets}>Refresh</div>
      </div>
    )
  }
}

function ProgressBar(props) {
  let width = props.percent + "%";
  return (
    <div className="UploadProgressContainer">
      <div style={{width}} className="UploadProgressBar"></div>
    </div>
  )
}

function WindowControls(props) {
  return (
    <div className="ProjectHistoryControls">
      <CloseButton handleClick={props.handleClose} />
    </div>
  )
}

class AssetManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title:"Asset Manager",
      isCompactMode: false
    }
    this.setTitle = this.setTitle.bind(this);
    this.toggleMinimize = this.toggleMinimize.bind(this);
    this.setCompactMode = this.setCompactMode.bind(this);
  }

  toggleMinimize(force) {
    if (typeof(force) === "boolean") {
      this.setState({minimized:force});
    } else {
      this.setState({minimized:!this.state.minimized});
    }
  }

  setTitle(newTitle) {
    this.setState({title:newTitle})
  }

  setCompactMode(isCompact) {
    this.setState({isCompactMode: isCompact});
  }

  render () {
    let containerClass = "WorldEditorContainer";
    if (this.state.minimized) {
      containerClass += " minimized";
    }
    if (this.state.isCompactMode) {
      containerClass += " compact";
    }

    return (
      <Draggable handle=".ProjectHistoryHeader">
      <div className={containerClass}>
        <div className="ProjectHistoryHeader"><span className="ProjectHistoryTitle">{this.state.title}</span><WindowControls minimized={this.state.minimized} toggleMinimize={this.toggleMinimize} handleClose={this.props.closeModal} /></div>
          {this.state.minimized ? null : <AssetsList setCompactMode={this.setCompactMode} closeModal={this.props.closeModal} activeProject={this.props.activeProject} modalOptions={this.props.modalOptions} canAddPasteModels={this.props.canAddPasteModels} />}
        </div>
      </Draggable>
    )
  }
}


let mapDispatchToProps = dispatch => ({
  closeModal:() => {
    dispatch(closeModal());
  }
})

let mapStateToProps = (state) => {
  const caps = selectPermissionCapabilities(state);

  return {
    activeProject:state.ui.activeProject,
    modalOptions:state.ui.modalOptions,
    canAddPasteModels: caps.canAddPasteModels
  };
}

const AssetManagerContainer = connect(mapStateToProps,mapDispatchToProps)(AssetManager)

export default AssetManagerContainer
